// @owners { team: patients-team }
import { ActionSheetV2 } from '@alto/design-system';
import React from 'react';
import { CommunicationPreferencesForm } from './CommunicationPreferencesForm';

export const CommunicationPreferencesActionSheet = () => {
  return (
    <ActionSheetV2
      title="Communication preferences"
      analyticsName="communication_preferences"
    >
      <CommunicationPreferencesForm />
    </ActionSheetV2>
  );
};
